var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJp = function SvgJp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "jp_svg__a",
    width: 25,
    height: 25,
    x: 0,
    y: 0,
    rx: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "jp_svg__c",
    width: 28,
    height: 20,
    x: 0,
    y: 0,
    rx: 2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jp_svg__d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#D81441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#BB0831"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jp_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jp_svg__a"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 0.5,
    y: 0.5,
    stroke: "#EAEAEA",
    rx: 12
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#jp_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jp_svg__e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jp_svg__c"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jp_svg__c",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 9.5,
    r: 5,
    fill: "url(#jp_svg__d)",
    mask: "url(#jp_svg__e)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 1.5,
    y: -2.5,
    stroke: "#EAEAEA",
    rx: 12
  }))))));
};
export default SvgJp;